import React from "react";
import { Form, Select, Input, InputNumber, message,DatePicker,Descriptions } from 'antd';
import TitleTop from '@pages/Assembly/titleTop';
import NHFormItem from '@components/common/NHFormItem/index';
import NHSelect from '@components/common/NHSelect';
import NHFetch from '@utils/NHFetch';
import * as moment from 'moment';
import './index.css';

import { getLoginUser } from "@utils/NHCore";


class GzxxForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            xsid: '',
            formInitData:{
            }
        }
    }

    componentDidMount() {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        if (userId) {
            this.setState({
                xsid: userId,
            });
        }
        this.queryRxxx(userId);
    }

    queryRxxx = xsid => {
        NHFetch('/newStudent/queryRxxx','GET',{xsid}).then(res=>{
            if (res && res.code == 200 && res.data) {
                let formInitData = {...res.data};
                this.setState({formInitData})
            }
        })
    }


    onSave = (cb) => {
        this.props.form.validateFields((error, values) => {
            if (error) {
                cb(false);
                return;
            }
            if (values.bysj) {
                values.bysj = values.bysj.valueOf();
            }
            values.xsid = this.state.xsid
            NHFetch('/newStudent/updateRxxx','POST',values).then(res=>{
                if (res && res.code === 200 && res.data) {
                    message.success(res.message);
                    this.queryRxxx(this.state.xsid)
                    this.setState({edit:false})
                    this.props.updateBlzt()
                    cb(true);
                } else {
                    cb(false)
                }
            })
        });

    }

    /** 验证必填项 */
    validateCustom = () => {
        const { edit, formInitData } = this.state;
        if(edit) {
            // 若是编辑模式 使用表单验证
            this.props.form.validateFields((err,values) => {
                if(err) {
                    return false
                }
                return true
            })
        } else {
            // 若非编辑模式 只能手动验证了
            // 需要验证的字段
            let requireFields = ['byxx','bysj','xslym','gkcj' ];
            let sum = 0;
            requireFields.map(item=>{
                // 验证必填的字段对应的值是否为空
                if(formInitData[item]&&formInitData[item]!=='') {
                    sum = sum + 0;
                } else {
                    sum = sum + 1;
                }
            }) 
            if( sum === 0 ) {
                return true
            } else {
                return false
            }
        }
    }

    render() {
        const { form } = this.props;
        const { edit, xsid,formInitData } = this.state;
        
        const renderView = ()=> {
            return (
                <div className="p-sw">
                    <Descriptions bordered>
                        <Descriptions.Item label="高中毕业学校（全称）">{formInitData.byxx}</Descriptions.Item>
                        <Descriptions.Item label="高中毕业时间">{formInitData.bysj?moment(formInitData.bysj).format('YYYY-MM-DD'):''}</Descriptions.Item>
                        <Descriptions.Item label="考生类别">{formInitData.xslymStr}</Descriptions.Item>
                        <Descriptions.Item label="考生号">{formInitData.ksh}</Descriptions.Item>
                        <Descriptions.Item label="高考总分">{formInitData.gkcj}</Descriptions.Item>
                        <Descriptions.Item label="是否应届生">{formInitData.bylx==='01'?'是':'否'}</Descriptions.Item>
                    </Descriptions>
                </div>
            );
        }
        const renderEdit = () => {
            const formItemLayout = {
                labelCol: {
                  xs: { span: 24 },
                  sm: { span: 8 },
                },
                wrapperCol: {
                  xs: { span: 24 },
                  sm: { span: 16 },
                },
              };
            return (
                <React.Fragment>
                <div className="p-sw">
                    <NHFormItem id={'byxx'}
                        label={'毕业学校'}
                        form={form}
                        required={true}
                        formItemLayout={formItemLayout}
                        initialValue={formInitData.byxx}
                    >
                        <Input maxLength={20} placeholder="毕业学校" />
                    </NHFormItem>
                    <NHFormItem id={'bysj'}
                        label={'毕业时间'}
                        form={form}
                        required={true}
                        formItemLayout={formItemLayout}
                        initialValue={formInitData.bysj?moment(formInitData.bysj):undefined}
                    >
                        <DatePicker />
                    </NHFormItem>
                    <NHFormItem id={'xslym'}
                        label={'考生类别'}
                        form={form}
                        required={true}
                        formItemLayout={formItemLayout}
                        initialValue={formInitData.xslym}
                    >
                        <NHSelect sign='DMK_XTGL_XSLYM' />
                    </NHFormItem>
                    <NHFormItem id={'ksh'}
                        label={'考生号'}
                        form={form}
                        formItemLayout={formItemLayout}
                        // hasFeedback={true}
                        // pattern={FormRules.MOBILE_PHONE_NUMBER}
                        initialValue={formInitData.ksh}
                    >
                        <Input disabled />
                    </NHFormItem>
                    <NHFormItem id={'gkcj'}
                        label={'高考总分'}
                        form={form}
                        required={true}
                        formItemLayout={formItemLayout}
                        // hasFeedback={true}
                        // pattern={FormRules.MOBILE_PHONE_NUMBER}
                        initialValue={formInitData.gkcj}
                    >
                        <InputNumber min={0} max={1000} />
                    </NHFormItem>
                    <NHFormItem id={'bylx'}
                        label={'是否应届生'}
                        form={form}
                        required={true}
                        formItemLayout={formItemLayout}
                        // hasFeedback={true}
                        // pattern={FormRules.MOBILE_PHONE_NUMBER}
                        initialValue={formInitData.bylx || '01'}
                    >
                        <Select>
                            <Select.Option value={'01'}>是</Select.Option>
                            <Select.Option value={'02'}>否</Select.Option>
                        </Select>
                    </NHFormItem>
                </div>
                </React.Fragment>
            );
        }
        return (
            <Form>
                <TitleTop
                    title="高中信息"
                    onEdit={type => {
                        this.setState({
                            edit: true
                        });
                    }}
                    onSave={cb => {
                        this.onSave(cb);
                    }}
                    onClose={() => {
                        this.setState({
                            edit: false
                        });
                    }}
                />
                {edit ? renderEdit():renderView()}
            </Form>
        );
    }
}

export default Form.create()(GzxxForm);


// WEBPACK FOOTER //
// ./app/pages/SelfHelp/updateInfo/gzxxForm.js